import React from 'react';
// import MypagAsContainer from 'containers/MypagAsContainer/MypagAsContainer';
import NewMypageAsContainer from 'containers/NewMypageAsContainer/NewMypageAsContainer';

export default function MypagAsPage() {
  return <NewMypageAsContainer />;
}
